import apiService from '../apiService'

const apiPath = '/logs'

export const logsController = (configService) => {
	const service = apiService(configService)
	return {
		saveLogCancelAuto: (params) => {
			return service.post({
				url: `${apiPath}/save-log-cancel-auto`,
				body: params,
			})
		},
		saveLogTaskApi: (params) => {
			return service.post({
				url: `${apiPath}/save-log-task-vif`,
				body: params,
			})
		},
		saveLogApiRes: (params) => {
			return service.post({
				url: `${apiPath}/save-log-api-res-vif`,
				body: params,
			})
		},
		saveLogCarAuto: (params) => {
			return service.post({
				url: `${apiPath}/save-log-car-auto`,
				body: params,
			})
		},
	}
}
